<template>
  <div class="rp-roles-modules__item-wrapper--card">
    <div class="rp-roles-modules__item-wrapper--card__title">
      <el-checkbox
        class="r-checkbox"
        size="mini"
        :value="isActive(component.id)"
        @change="beforeToggle(module.name, component.id)"
      >
        <r-text>{{ $t(`${module.name}:${component.value}`) }}</r-text>
      </el-checkbox>
      <div
        class="rp-roles-modules__item-wrapper--card__toggler"
        @click="cardToggleHandler()"
      >
        <r-icon
          :name="isOpen ? 'chevron-up' : 'chevron-down'"
          :size="20"
        />
      </div>
    </div>
    <div
      v-if="isOpen"
      class="rp-roles-modules__item-wrapper--card-wrapper"
    >
      <r-text class="rp-roles-modules__item-wrapper--card-wrapper__title">
        Настройка компонента
      </r-text>
      <div
        v-for="instrument in component.instruments"
        :key="instrument.id"
        class="rp-roles-modules__item instrument"
      >
        <el-checkbox
          class="r-checkbox"
          size="mini"
          :value="isActive(component.id, instrument.id)"
          @change="beforeToggle(module.name, component.id, instrument.id)"
        >
          <r-text>
            {{ $t(`${module.name}:${component.value}:${instrument.name}`) }}
          </r-text>
        </el-checkbox>
      </div>
    </div>
  </div>
</template>

<script>
import { isInstrumentActive, isComponentActive } from './helpers'

export default {
  props: {
    module: {
      type: Object,
      required: true
    },
    component: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isOpen: false
    }
  },
  computed: {
    roleModules() {
      return this.$store.state.rolePermission.rolePerms?.modules || []
    }
  },
  watch: {
    roleModules: {
      handler: function() {
        this.$forceUpdate()
      },
      deep: true
    }
  },
  methods: {
    cardToggleHandler() {
      this.isOpen = !this.isOpen
    },
    isActive(component, instrument) {
      if (instrument) {
        return isInstrumentActive(this.roleModules, component, instrument)
      } else {
        return isComponentActive(this.roleModules, component)
      }
    },
    beforeToggle(module, component, instrument) {
      this.$emit('before-toggle', {
        module,
        component,
        instrument
      })
    }
  }
}
</script>

<style lang="scss">
.rp-roles-modules__item-wrapper--card {
  overflow: hidden;
  border-radius: var(--border-radius);
  background-color: var(--bg_containers) !important;
  padding: 8px;

  .el-checkbox__label {
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__toggler {
    cursor: pointer;
    width: 40px;
    display: flex;
    justify-content: flex-end;
  }

  &__title {
    display: flex;
    justify-content: space-between;
  }

  &-wrapper {
    &__title {
      margin: 8px 0 4px;
    }
  }

  .rp-roles-modules__item {
    &.instrument {
      margin-bottom: 8px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>

<i18n>
{
  "ru": {
    "gis:map": "Карта",
    "gis:map:Editor": "Редактирование",
    "gis:map:Diagrams": "Диаграммы",
    "gis:map:Styles": "Стилизация",
    "gis:map:Filters": "Фильтры",
    "gis:map:Heatmaps": "Тепловая карта",

    "gis:book": "Справочник",
    "gis:book:Editor": "Редактирование",
    "gis:book:Filters": "Фильтры",
    "gis:book:Columns Settings": "Настройка отображения столбцов"
  }
}
</i18n>
